import { FC } from 'react';
import { merge } from '../../utils/utility';
import { Trapezium, TrapeziumProps } from './Trapezium';

export enum FadeColor {
  LIGHT,
  DARK
}

interface FadeTrapeziumProps extends TrapeziumProps {
  fadeColor: FadeColor;
}

export const FadeTrapezium: FC<FadeTrapeziumProps> = ({ fadeColor, slant, reverse, className }) => {
  let baseClass = '';
  let fadeClass = `${reverse ? 'bg-gradient-to-r' : 'bg-gradient-to-l'} from-transparent`;

  switch (fadeColor) {
    case FadeColor.DARK:
      baseClass = merge(baseClass, 'bg-primary-800 opacity-50');
      fadeClass = merge(fadeClass, 'via-transparent to-primary-800');
      break;
    case FadeColor.LIGHT:
      baseClass = merge(baseClass, 'bg-primary-50 opacity-90');
      fadeClass = merge(fadeClass, 'to-primary-50');
      break;
  }

  return (
    <>
      <Trapezium reverse={reverse} slant={slant} className={merge(baseClass, className)} />
      <Trapezium reverse={reverse} slant={slant} className={merge(fadeClass, className)} />
    </>
  );
};
